export const en = {
  header: {
    title: 'Dr. Putkaradze',
  },
  nav: {
    about: 'About',
    gallery: 'Gallery',
    services: 'Services',
    education: 'Educational Resources',
    news: 'News',
    askDoctor: 'Ask Doctor',
    contact: 'Contact'
  },
  gallery: {
    title: 'Gallery',
    subtitle: 'Photos from our medical practice and patient care',
  },
  news: {
    title: 'News',
    subtitle: 'Latest updates and articles from Dr. Putkaradze',
    readMore: 'Read More',
    backToNews: 'Back to News',
    publishedOn: 'Published on',
    noPosts: 'No news articles available yet.',
    admin: {
      title: 'News Management',
      subtitle: 'Create and manage news posts',
      totalPosts: 'Total Posts',
      published: 'Published',
      drafts: 'Drafts',
      createPost: 'Create Post',
      editPost: 'Edit Post',
      deletePost: 'Delete Post',
      deleteConfirm: 'Are you sure you want to delete this post?',
      form: {
        titleEn: 'Title (English)',
        titleKa: 'Title (Georgian)',
        titleRu: 'Title (Russian)',
        contentEn: 'Content (English)',
        contentKa: 'Content (Georgian)',
        contentRu: 'Content (Russian)',
        image: 'Featured Image',
        uploadImage: 'Upload Image',
        changeImage: 'Change Image',
        removeImage: 'Remove Image',
        publish: 'Publish',
        saveDraft: 'Save as Draft',
        cancel: 'Cancel',
        save: 'Save',
        publishing: 'Publishing...',
        saving: 'Saving...'
      }
    }
  },
  education: {
    title: 'Educational Resources',
    subtitle: 'Curated content to help you better understand traumatology and orthopedics',
    georgian: {
      title: 'Educational Resources in Georgian',
      watchVideo: 'Watch Video'
    },
    english: {
      title: 'Educational Resources in English',
      watchVideo: 'Watch Video'
    },
    russian: {
      title: 'Educational Resources in Russian',
      watchVideo: 'Watch Video'
    }
  },
  hero: {
    title: 'Dr. Giorgi Putkaradze',
    subtitle: 'Renowned Specialist in Trauma-Orthopedics',
    cta: 'Book Appointment',
  },
  about: {
    sectionTitle: 'Medical Experience',
    certifiedSpecialist: 'Certified Specialist',
    aoMethodology: 'AO Methodology',
    internationalStandards: 'International Standards',
  },
  stats: {
    childbirths: {
      number: '5,000+',
      text: 'Successful Surgeries',
    },
    complications: {
      number: '2,500+',
      text: 'Joint Replacements',
    },
    surgeries: {
      number: '1,000+',
      text: 'Complex Case Re-implantations',
    },
    experience: {
      number: '10+',
      text: 'Years of Experience',
    },
  },
  expertise: {
    title: 'Expertise & Specializations',
    subtitle: 'With years of experience in trauma-orthopedics, Dr. Giorgi Putkaradze has successfully treated thousands of patients both conservatively and with complex surgical interventions.',
    services: {
      obstetrics: {
        title: 'Traumatology Services',
        description: 'Diagnosis and treatment according to AO methodological guidelines: bone fractures, dislocations, sprains, ligament and tendon injuries — both household and sports injuries.',
      },
      surgery: {
        title: 'Orthopedic Services',
        description: 'Arthrosis, arthritis, joint pain, movement restriction, evaluation and treatment of inflammatory and degenerative processes, endoprosthetics of all major joints.',
      },
      health: {
        title: 'Complex Case Management',
        description: 'Reconstructive surgery using revision reimplantation techniques.',
      },
      additional: {
        title: 'Conservative Treatment',
        description: 'Immobilization, injection therapy, proper planning of physical activity, individual rehabilitation and recovery programs.',
      },
    },
  },
  contact: {
    title: 'Contact Information',
    subtitle: 'Schedule an appointment or get in touch with any questions you may have.',
    getInTouch: 'Get in Touch',
    mobile: 'Mobile',
    office: 'Office',
    currentWorkplaces: 'Current Workplaces',
    phone: '+995 596 09 10 00',
    landline: '',
    email: 'futkaradzegiorgi@gmail.com',
    clinics: {
      openHeart: 'Batumi Medical Center (Batumi)',
      barbara: 'Nuralidze Uniquemed (Kutaisi)'
    },
    hours: 'Monday - Friday: 9:00 AM - 6:00 PM',
    appointments: 'Appointments available',
  },
  footer: {
    copyright: '© {year} Dr. Giorgi Putkaradze. All rights reserved.',
  },
  aiChat: {
    title: 'AI Medical Assistant',
    backToHome: 'Back to Home',
    description: 'This AI assistant can help you with:',
    capabilities: {
      general: 'General medical information and guidelines',
      symptoms: 'Common symptoms and conditions',
      recommendations: 'Basic health recommendations',
      pregnancy: 'Traumatology and orthopedics information'
    },
    disclaimer: 'Please note: The AI provides general information only and should not replace professional medical advice.',
    askDoctor: {
      title: 'Ask Dr. Putkaradze',
      description: 'Have a specific question for Dr. Putkaradze? Leave your question here, and the doctor will personally review and respond to your inquiry during business hours. You can also attach relevant medical documents to help the doctor better understand your situation.',
      instructions: {
        title: 'How to Ask a Question',
        steps: 'Provide your contact information so we can reach you\nWrite your medical question in detail\nAttach relevant medical documents (optional)\nSubmit your question and wait for response via email'
      },
      attachments: {
        title: 'Supporting Documents',
        description: 'You can attach relevant medical documents such as:',
        voice: {
          title: 'Voice Recording',
          description: 'You can record your voice to explain your question in detail',
          start: 'Start Recording',
          stop: 'Stop Recording',
          delete: 'Delete Recording',
          duration: 'Recording duration: {seconds} seconds',
          instructions: 'Click to start recording your voice message. Speak clearly and describe your medical concern in detail.'
        },
        types: 'Lab test results\nMedical imaging reports\nPrevious medical records\nPrescription documents',
        limits: 'Accepted formats: Images, PDF, DOC. Max size: 10MB per file',
        button: 'Add Documents',
        remove: 'Remove'
      },
      emailNote: 'You will receive the response via email',
      namePlaceholder: 'Your name',
      emailPlaceholder: 'Your email',
      phonePlaceholder: 'Phone (optional)',
      label: 'Your Question',
      placeholder: 'Type your medical question here...',
      submit: 'Submit Question',
      error: 'There was an error submitting your question. Please try again.',
      success: {
        title: 'Thank you for your question!',
        message: 'Dr. Putkaradze will review and respond to your inquiry via email as soon as possible.',
        askAnother: 'Ask another question'
      }
    }
  },
  askDoctor: {
    form: {
      namePlaceholder: 'Your name',
      emailPlaceholder: 'Your email'
    }
  },
  chat: {
    title: 'AI Medical Assistant',
    subtitle: 'Get expert medical guidance available 24/7',
    disk: {
      medicalAssistance: 'Medical Assistance',
      healthGuidance: 'Health Guidance',
      expertSupport: 'Expert Support',
      available: '24/7 Available'
    },
    welcome: 'Ask me any medical questions based on Dr. Putkaradze\'s expertise',
    placeholder: 'Type your question here...',
    error: 'I apologize, but I\'m having trouble connecting. Please try again.',
    online: 'Online',
    typing: 'Typing...',
    thinking: 'Thinking...',
    inputAriaLabel: 'Message input',
    sendAriaLabel: 'Send message',
    quickReplies: {
      appointments: 'How can I schedule an appointment?',
      services: 'What services do you offer?',
      location: 'Where is your clinic located?'
    }
  },
  admin: {
    portal: 'Admin Portal',
    login: 'Admin Login',
    signIn: 'Sign In',
    signingIn: 'Signing In...',
    email: 'Email address',
    password: 'Password',
    backToHome: 'Back to Home',
    signInSubtitle: 'Sign in to access the admin dashboard',
    authError: 'Authentication Error',
    accessInfo: 'Only authorized personnel can access this area. Please contact the system administrator if you need access.'
  },
  chatHistory: {
    backToChat: 'Back to Chat',
    title: 'Chat History',
    noConversations: 'No previous conversations found.',
    view: 'View',
    delete: 'Delete',
    deleteConfirmation: 'Are you sure you want to delete this conversation? This action cannot be undone.'
  },
  response: {
    respondToPatient: 'Respond to Patient',
    patientQuestion: 'Patient Question:',
    aiResponse: 'AI Generated Response:',
    placeholder: 'Edit or write your response here...',
    downloadPdf: 'Download PDF',
    cancel: 'Cancel',
    send: 'Send'
  },
  email: {
    title: 'Medical Response - Dr. Putkaradze',
    header: 'Dr. Putkaradze Medical Platform',
    subheader: 'Professional Medical Consultation Response',
    patientInfo: 'Patient Information',
    yourQuestion: 'Your Question',
    medicalResponse: 'Medical Response',
    footer: 'Professional Healthcare Consultation Services',
    generated: 'Generated'
  },
  locations: {
    tbilisiGeorgia: 'Tbilisi, Georgia'
  },
  adminGuidelines: {
    title: 'How to Respond',
    subtitle: 'Follow these steps when answering patient questions',
    steps: {
      step1: 'Read the question and attachments',
      step2: 'Ask AI assistant for help if needed',
      step3: 'Click "Respond" to open the response form',
      step4: 'Edit or write your response',
      step5: 'Click "Send" to email the patient'
    },
    collapse: 'Hide',
    expand: 'Show'
  }
};